/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UploadedFileResponseDto } from './UploadedFileResponseDto';
import {
    UploadedFileResponseDtoFromJSON,
    UploadedFileResponseDtoFromJSONTyped,
    UploadedFileResponseDtoToJSON,
    UploadedFileResponseDtoToJSONTyped,
} from './UploadedFileResponseDto';

/**
 * 
 * @export
 * @interface UploadedFileWithSasTokenResponseDto
 */
export interface UploadedFileWithSasTokenResponseDto {
    /**
     * 
     * @type {UploadedFileResponseDto}
     * @memberof UploadedFileWithSasTokenResponseDto
     */
    file: UploadedFileResponseDto;
    /**
     * 
     * @type {string}
     * @memberof UploadedFileWithSasTokenResponseDto
     */
    uploadSasUrl: string;
}

/**
 * Check if a given object implements the UploadedFileWithSasTokenResponseDto interface.
 */
export function instanceOfUploadedFileWithSasTokenResponseDto(value: object): value is UploadedFileWithSasTokenResponseDto {
    if (!('file' in value) || value['file'] === undefined) return false;
    if (!('uploadSasUrl' in value) || value['uploadSasUrl'] === undefined) return false;
    return true;
}

export function UploadedFileWithSasTokenResponseDtoFromJSON(json: any): UploadedFileWithSasTokenResponseDto {
    return UploadedFileWithSasTokenResponseDtoFromJSONTyped(json, false);
}

export function UploadedFileWithSasTokenResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadedFileWithSasTokenResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'file': UploadedFileResponseDtoFromJSON(json['file']),
        'uploadSasUrl': json['uploadSasUrl'],
    };
}

export function UploadedFileWithSasTokenResponseDtoToJSON(json: any): UploadedFileWithSasTokenResponseDto {
    return UploadedFileWithSasTokenResponseDtoToJSONTyped(json, false);
}

export function UploadedFileWithSasTokenResponseDtoToJSONTyped(value?: UploadedFileWithSasTokenResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'file': UploadedFileResponseDtoToJSON(value['file']),
        'uploadSasUrl': value['uploadSasUrl'],
    };
}

